import React, { useEffect, useState } from "react";
import { Avatar, Row, Col, Card, Tabs, Typography, message } from "antd";
import axios from "axios";
import { avatar01 } from "../../../commons/PanelImagepath";
import { isAuthenticated } from "../../../commons/Auth/auth";
import UpdateProfile from "./UpdateProfile";
import UpdatePassword from "./UpdatePassword";
import "../../../normalUsers/components/profile/ProfilePage.css";

import { useTranslation } from "react-i18next";
import DeleteAccount from "../../../commons/Auth/DeleteAccount";
const { Title, Text } = Typography;

const Profile = () => {
  const { t } = useTranslation("dashboard");
  const [user, setUser] = useState({});

  const getUser = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/users/user/${isAuthenticated()?.serviceProviderId}`,
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        }
      );
      if (res.status === 200 || res.status === 304) {
        setUser(res.data);
      } else {
        message.error(res.data.errorMessage);
      }
    } catch (err) {
      message.error(err.message);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  const details = [
    { label: t("Name:"), value: `${user?.firstName || ""} ${user?.lastName || ""}`.trim() },
    { label: t("Date of Birth:"), value: user?.dob },
    { label: t("Email:"), value: user?.email },
    { label: t("Mobile:"), value: user?.phone },
    {
      label: t("Address:"),
      value: `${user?.city || ""}, ${user?.state || ""} - ${user?.zipCode || ""}, ${user?.country || ""}`
    }
  ];

  const tabs = [
    {
      key: "1",
      label: t("About"),
      children: (
        <Card
          title={t("Personal Details")}
          extra={<UpdateProfile data={user} updateParent={getUser} />}
        >
          <Row gutter={[16, 12]}>
            {details.map(item => (
              <React.Fragment key={item.label}>
                <Col xs={24} sm={8}>
                  <Text type="secondary">{item.label}</Text>
                </Col>
                <Col xs={24} sm={16} className="profile-page__value">
                  {item.value}
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </Card>
      )
    },
    {
      key: "2",
      label: t("Password"),
      children: (
        <Card title={t("Change Password")}>
          <UpdatePassword />
          <DeleteAccount />
        </Card>
      )
    }
  ];

  return (
    <div className="profile-page">
      <Card>
        <div className="profile-page__identity">
          <Avatar
            size={{ xs: 64, sm: 80, md: 100, lg: 100, xl: 100, xxl: 100 }}
            src={user?.picture?.url ? user?.picture?.url : avatar01}
          />
          <div className="profile-page__who">
            <Title level={4}>
              {user?.firstName} {user?.lastName}
            </Title>
            <Text type="secondary">{user?.email}</Text>
            {user?.description && <p>{user?.description}</p>}
          </div>
        </div>
      </Card>
      <Tabs defaultActiveKey="1" items={tabs} />
    </div>
  );
};

export default Profile;
